import styled from 'styled-components';
import { animated } from 'react-spring';

import Icon from '../Icon';

export const Checkbox = styled.input.attrs({
  type: 'checkbox'
})`
  display: none;
`;

const Switch = styled.button.attrs({
  type: 'button'
})`
  position: relative;
  border-radius: 14px;
  border: none;
  height: 28px;
  width: 48px;
  box-shadow: 0 0 1px 1px #dbdbdb;
  padding: 2px;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(21, 156, 228, 0.4);
  }
`;

export const AnimatedSwitch = animated(Switch);

const Notch = styled.div`
  background: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 50%;
  height: 24px;
  width: 23px;
  top: 2px;
  position: absolute;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AnimatedNotch = animated(Notch);

export const On = styled(Icon).attrs({
  icon: 'TR5-Toggle_check'
})`
  height: 18px;
  width: 18px;
  stroke: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  stroke-width: 2px;
`;

export const Off = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  height: 8px;
  width: 8px;
  stroke: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  stroke-width: 2px;
`;

export const StyledToggle = styled.div`
  display: flex;
  align-items: center;
`;
